import { useQuery } from '@tanstack/react-query';

import { fetchTagsEnrichments } from '../services/api/enrichments';

import type { EnrichmentResponse } from '../types';

export const useTagsEnrichments = () => {
  return useQuery<EnrichmentResponse[]>({
    queryKey: ['enrichments'],
    queryFn: fetchTagsEnrichments,
    initialData: [],
  });
};
